import { render, staticRenderFns } from "./ModalCreateToDo.vue?vue&type=template&id=771c3228&scoped=true"
import script from "./ModalCreateToDo.vue?vue&type=script&lang=js"
export * from "./ModalCreateToDo.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateToDo.vue?vue&type=style&index=0&id=771c3228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771c3228",
  null
  
)

export default component.exports